'use client';
import { jsxs, jsx } from "react/jsx-runtime";
import { useScreenSize, cn } from "@tameeni/shared-logic";
import * as React from "react";
import { Drawer, DrawerTrigger, DrawerContent, DrawerHeader, DrawerFooter, DrawerTitle, DrawerDescription, DrawerClose } from "../drawer/drawer.js";
import { Sheet, SheetTrigger, SheetContent, SheetHeader, SheetFooter, SheetTitle, SheetDescription, SheetClose, SheetCloseButton } from "../sheet/sheet.js";
function ResponsiveSheetDrawer({
  children,
  trigger,
  side = "right",
  open,
  onOpenChange,
  className
}) {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsxs(Sheet, { open, onOpenChange, children: [
      trigger && /* @__PURE__ */ jsx(SheetTrigger, { asChild: true, children: trigger }),
      /* @__PURE__ */ jsx(
        SheetContent,
        {
          side,
          className: cn("flex flex-col p-0", className),
          children
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs(Drawer, { open, onOpenChange, children: [
    trigger && /* @__PURE__ */ jsx(DrawerTrigger, { asChild: true, children: trigger }),
    /* @__PURE__ */ jsx(DrawerContent, { className: cn("flex flex-col p-0", className), children })
  ] });
}
const ResponsiveSheetDrawerTrigger = ({
  children,
  ...props
}) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetTrigger, { ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerTrigger, { ...props, children });
};
const ResponsiveSheetDrawerContent = React.forwardRef(({ children, side = "right", className, ...props }, ref) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(
      SheetContent,
      {
        ref,
        side,
        className: cn("flex flex-col p-0 h-full", className),
        ...props,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    DrawerContent,
    {
      ref,
      className: cn("flex flex-col p-0 max-h-[85vh]", className),
      ...props,
      children
    }
  );
});
ResponsiveSheetDrawerContent.displayName = "ResponsiveSheetDrawerContent";
const ResponsiveSheetDrawerHeader = ({
  children,
  className,
  ...props
}) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetHeader, { className: cn("p-4 shrink-0", className), ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerHeader, { className: cn("p-4 shrink-0", className), ...props, children });
};
const ResponsiveSheetDrawerFooter = ({
  children,
  className,
  ...props
}) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetFooter, { className: cn("p-4 shrink-0", className), ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerFooter, { className: cn("p-4 shrink-0", className), ...props, children });
};
const ResponsiveSheetDrawerTitle = React.forwardRef(({ children, className, ...props }, ref) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetTitle, { ref, className, ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerTitle, { ref, className, ...props, children });
});
ResponsiveSheetDrawerTitle.displayName = "ResponsiveSheetDrawerTitle";
const ResponsiveSheetDrawerDescription = React.forwardRef(({ children, className, ...props }, ref) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetDescription, { ref, className, ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerDescription, { ref, className, ...props, children });
});
ResponsiveSheetDrawerDescription.displayName = "ResponsiveSheetDrawerDescription";
const ResponsiveSheetDrawerClose = ({
  children,
  ...props
}) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(SheetClose, { ...props, children });
  }
  return /* @__PURE__ */ jsx(DrawerClose, { ...props, children });
};
const ResponsiveSheetDrawerCloseButton = (props) => {
  const { isDesktop } = useScreenSize();
  if (isDesktop) {
    return /* @__PURE__ */ jsx(
      SheetCloseButton,
      {
        ...props,
        className: cn(
          "focus-visible:ring-0 focus-visible:ring-offset-0",
          props.className
        )
      }
    );
  }
  return /* @__PURE__ */ jsx(DrawerClose, { asChild: true, children: /* @__PURE__ */ jsx(
    SheetCloseButton,
    {
      ...props,
      className: cn(
        "focus-visible:ring-0 focus-visible:ring-offset-0",
        props.className
      )
    }
  ) });
};
const ResponsiveSheetDrawerBody = ({
  children,
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex-1 overflow-y-auto px-4 py-2", className),
      ...props,
      children
    }
  );
};
export {
  ResponsiveSheetDrawer,
  ResponsiveSheetDrawerBody,
  ResponsiveSheetDrawerClose,
  ResponsiveSheetDrawerCloseButton,
  ResponsiveSheetDrawerContent,
  ResponsiveSheetDrawerDescription,
  ResponsiveSheetDrawerFooter,
  ResponsiveSheetDrawerHeader,
  ResponsiveSheetDrawerTitle,
  ResponsiveSheetDrawerTrigger
};
